import {eventBus} from "@/lib/eventbus";
import _ from 'lodash';
interface EventBindData {
    eventName:string,
    handler:Function
}

export class EventBusManager{
    handlerCache:Array<EventBindData>;

    constructor(){
        this.handlerCache = new Array<EventBindData>();
    }


    on(eventName:string,handler:Function){
        let evt = eventBus.$on(eventName,handler);
        let cacheData:EventBindData = {
            eventName:eventName,
            handler:handler
        }
        this.handlerCache.push(cacheData);
    }
    clear(){
        _.each(this.handlerCache,(val)=>{
            eventBus.$off(val.eventName,val.handler);
        })

        this.handlerCache = [];
    }
}
